import { render, staticRenderFns } from "./gravy_packaging_list.vue?vue&type=template&id=638fb092&scoped=true"
import script from "./gravy_packaging_list.vue?vue&type=script&lang=js"
export * from "./gravy_packaging_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638fb092",
  null
  
)

export default component.exports